import React, { useState } from 'react'
import { DataGrid, NGODatePicker } from '../../../common';
import usePermissions from '../../../utils/userPermissions';
import { useTranslation } from 'react-i18next';
import { MdOutlineMailOutline } from "react-icons/md";
import moment from 'moment';
import {gridRowStyles} from '../../../utils/configs';
import { getDateFromTimezone } from './Cards';
import { APIEndpoint } from '../../../utils/axios';
import { formatDateByTimezone,getCultureFromLs } from '../../../utils/commonFunctions';
import { SectorRenderer } from "../../sales/inner-components/renderers";


const body = {
  page:1,
  filters:[],
  limit:50
}

const Columns = [
  {field: "flightDate",headerName: "Flight Date",flex:1,minWidth:100},
  {field: "txnDate",headerName: "Txn Date Time",flex:1,minWidth:150,cellStyle:gridRowStyles,resizable:true,valueGetter: params => {
    return params.data ? moment(params.data?.txnDate).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
}},
    { field: 'storeName', headerName: 'Sector',resizable:true,flex:1, minWidth: 165, width:170,maxWidth:250,cellRendererSelector: (params) => {
      return {
        component: SectorRenderer,
      };
    }},
{field: "orderNo",headerName: "Order No",flex:1,minWidth:150,cellStyle:gridRowStyles,resizable:true},
{field: "paxName",headerName: "Pax Name",flex:1,minWidth:170,cellStyle: {
  whiteSpace: 'nowrap',
  overflow:'hidden',
  textOverflow:'ellipsis',
},resizable:true},
{field: "pnr",headerName: "PNR",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true},
{field: "seatNumber",headerName: "Seat No",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true},
{field: "cardNo",headerName: "Card No",flex:1,minWidth:130,cellStyle: gridRowStyles,resizable:true},
{field: "amount",headerName: "Txn Amount",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true},
{field: "currency",headerName: "Currency",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true},
{field: "syncDate",headerName: "Sync Date Time",flex:1,minWidth:150,cellStyle:gridRowStyles,resizable:true,valueGetter: params => {
  return params.data?.syncDate ? moment(params.data.syncDate).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
}},
{field: "paymentStatus",headerName: "Payment Status",flex:1,minWidth:140},
{field: "bankTxnId",headerName: "Bank Ref No",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true},
{field: "orderStatus",headerName: "Order Status",flex:1,minWidth:140},
  {field: "flightNumber",headerName: "Flight No",flex:1,minWidth:140,cellStyle: gridRowStyles,resizable:true,},
  {field: "amountCredited",headerName: "Amount Credited",flex:1,minWidth:130, valueGetter:(params)=>{
    return params?.data?.paymentStatus === "Completed" ? params?.data?.amount:null
  }},
  { field: 'actions',pinned:'right',autoResize:true,headerName:"Actions",width:180,cellRenderer: ActionComponent },
]
function ActionComponent (props) {

  const {data}=props;
  const handleEmailClick = () => {
    const subject = `Payment Collection - ${data?.orderNo}`;
    const body = ``;
    const mailtoLink = `mailto:customer@akasaair.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (<>
  {data!== undefined? <MdOutlineMailOutline title='Send Mail' color='#fff' size={20} style={{cursor:"pointer"}} onClick={handleEmailClick}/>:<></>}
  </>

);
};
export const CardReconciliation = () => {
  const { hasPermission: viewCardRecon } = usePermissions('view', "card-reconciliation");
  const [perPageLimit, ] = useState(50);
  const [filterData, setFilterData] = useState({
    flightDate:"",
    flightNumber:"",
    pnrNumber:"",
    orderNumber:"",
    crewNumber:"",
    orderStatus:""
  })
  const [isReloadTable, setIsReloadTable] = useState(false)
  const { ready } = useTranslation();



  async function fetchCardTransactions(page=1, perPage=50){
    if(!viewCardRecon){
      return {items:[],count:0}
    }
    body.filters = [];
    body.page = page;
    body.limit = perPage;
    if(filterData.flightNumber){
      body.filters.push({flightNumber:filterData.flightNumber})
    }
    if(filterData.orderNumber){
      body.filters.push({orderNo:filterData.orderNumber})
    }
       if(filterData.crewNumber){
      body.filters.push({crewId:filterData.crewNumber})
    }
    if(filterData.pnrNumber){
      body.filters.push({pnr:filterData.pnrNumber})
    }
    if(filterData.flightDate){
      body.filters.push({flightDate:formatDateByTimezone(filterData.flightDate)})
    }
    if(filterData.orderStatus){
      body.filters.push({orderStatus:filterData.orderStatus})
    }
    try {
      const res = await APIEndpoint.post("payments/card/transactions",JSON.stringify(body))
      return res
    } catch (error) {
      console.log(error)
    }
  }

  function isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  const handleInputChange = (e) => {
    setIsReloadTable(!isReloadTable)
    if(!e.target.value){
      setFilterData(prev=>({...prev,flightDate:null}))
      return;
    }
    let { name, value } = e.target;
    if(!isValidDate(value)) return;
    if (name === "flightDate") {
      let dataVal = getDateFromTimezone(value).toDate();
      setFilterData((prev) => {
        return { ...prev, flightDate: dataVal };
      });
    }
  };
  function onSearchInpChange(e){
    setIsReloadTable(!isReloadTable)
    let { name, value } = e.target;
    setFilterData(prev=>({...prev,[name]:value}))
  }
  return (
    <div className="flexCol full-flex ag-theme-alpine-dark">
     {viewCardRecon?<><div
          className="flex flexRow alignItemsCenter"
        >
          <div className='felxCol m-2'>
            <NGODatePicker
              value={filterData.flightDate}
              name='flightDate'
              onChange={handleInputChange}
              placeholder="Flight Date"
              isClearable={true}
            />
          </div>
          <div className='flexCol m-2'>
          <div className='operations-in'>
            <input
              className="search-crew searchReconFilter"
              onChange={onSearchInpChange}
              type="search"
              name='flightNumber'
              placeholder="Search Flight Number"
              value={filterData.flightNumber||null}
            />
          </div>
          </div>


          <div className="flexCol m-2">
          <div className='operations-in'>
            <input
             name='pnrNumber'
             className="search-crew searchReconFilter"
             onChange={onSearchInpChange}
             type="search"
             placeholder="Search PNR Number"
             value={filterData.pnrNumber||null}
            />
          </div>
          </div>
          <div className="flexCol m-2">
          <div className='operations-in'>
            <input
             name='orderNumber'
             className="search-crew searchReconFilter"
             onChange={onSearchInpChange}
             type="search"
             placeholder="Search Order Number"
             value={filterData.orderNumber||null}
            />
          </div>

          </div>
          <div className="flexCol m-2">
          <div className='operations-in'>
          <input
          name='crewNumber'
          className="search-crew searchReconFilter"
          onChange={onSearchInpChange}
          type="search"
          placeholder="Search Crew Name/ID"
          value={filterData.crewNumber||null}
          />
          </div>
          </div>

          <div className="flexCol m-2">
          <div className=''>
            <select onChange={onSearchInpChange} style={{fontWeight:"400",fontSize:"0.8rem"}} name="orderStatus" className='select-item darkBlue-bg' id="">
              <option value="">Order Status</option>
              <option value="accepted">Accepted</option>
              <option value="cancelled">Cancelled</option>
              <option value="denied">Denied Demand</option>
            </select>
          </div>
          </div>
        </div>

    <DataGrid
        className="full-flex"
        columns={[...Columns]}
        initialPageLimit={perPageLimit}
        showDefaultFilters={false}
        getRows={fetchCardTransactions}
        columnResize={true}
        rowSelection="multiple"
        resetDataSource={isReloadTable}
      /></> :<></>}
        {
    !ready &&<div className='overlay_hide sub'></div>
    }
    </div>
  );
}